import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { getReturnAmountList } from "@heartinz/finance";
import uRLs from "../../../utils/baseUtils";
import { secondaryQuanity } from "../../../utils/ProductHandleChange";
import { useAuth } from "../../../context/AuthProvider";
import { AddIcon, CheckIcon, CloseIcon } from "../../../constants/Icons";

const AddRetrunProduct = ({ data, addToCart, onClose }) => {
  // console.log(data);
  const { settings } = useAuth();
  const [inputValues, setInputValues] = useState({
    qty: "1",
    returnPrice: "",
    totalReturnAmount: "",
    remark: "",
    conditions: "",
  });

  const qtyInputRef = useRef(null);
  const totalReturnRef = useRef(null);

  const [addToStock, setAddToStock] = useState(true);

  const [selectedUnit, setSelectedUnit] = useState(
    data?.unitConfig?.primaryUnitCode || "",
  );

  const [touched, setTouched] = useState({
    returnPrice: false,
    totalReturnAmount: false,
  });

  const [returnPriceLock, setReturnPriceLock] = useState("RETURN_PRICE");
  const [unitData, setUnitData] = useState();
  const [soldPriceError, setSoldPriceError] = useState("");
  const [errors, setErrors] = useState({});
  const soldPriceRef = useRef(null);
  const buttonRef = useRef(null);
  const isInitialMount = useRef(true);
  const [priceState, setPriceState] = useState({
    mrp: data.mrp,
    baseprice: data.baseprice,
  });

  useEffect(() => {
    let salePriceSubunit =
      data.cIndex !== undefined
        ? data.soldprice || data.saleprice || 0
        : data.saleprice || 0;

    if (data?.cMode === "EDIT") {
      setInputValues({
        soldprice: CurrencyConverter.toCurrency(salePriceSubunit, "INR"),
        qty: String(data.quantity ?? 1),
        returnPrice: CurrencyConverter.toCurrency(data.returnPrice || 0, "INR"),
        totalReturnAmount: CurrencyConverter.toCurrency(
          data.lineTotalReturnPrice || 0,
          "INR",
        ),
        remark: data.remark || "",
        conditions: data.conditions || "",
      });
      setAddToStock(data?.addToStock);
      setReturnPriceLock(data.returnPriceLock || "RETURN_PRICE");
    } else {
      // const amountList = getReturnAmountList(
      //   data.mrp,
      //   data.saleprice,
      //   data.soldprice,
      //   0,
      //   data.lineTotalSoldPrice,
      //   data.taxpercentage,
      //   1,
      //   "LINE_TOTAL",
      // );

      setInputValues({
        soldprice: CurrencyConverter.toCurrency(salePriceSubunit, "INR"),
        qty: "0",
        returnPrice: CurrencyConverter.toCurrency(data.soldprice, "INR"),
        // totalReturnAmount: CurrencyConverter.toCurrency(
        //   amountList.lineTotalReturnPrice,
        //   "INR",
        // ),
        totalReturnAmount: "",
        remark: "",
        conditions: "",
      });

      setReturnPriceLock("RETURN_PRICE");
      setAddToStock(data?.isStock === true);
    }

    if (isInitialMount.current) {
      isInitialMount.current = false;

      setTimeout(() => {
        qtyInputRef.current?.focus();
        qtyInputRef.current?.select();
      }, 0);
    }
  }, [data]);

  useEffect(() => {
    setSelectedUnit(unitData?.primaryUnitCode);
  }, [unitData]);

  const allUnits = [
    ...(settings?.defaultUnits || []).map((u) => ({
      unitCode: u.unitCode,
      unitName: u.unitName,
    })),
    ...(settings?.storeUnits || []).map((u) => ({
      unitCode: u.unitCode,
      unitName: u.unitName,
    })),
  ];

  const targetUnitCode = data?.isSecondaryUnit
    ? data?.unitConfig?.secondaryUnitCode
    : data?.unitConfig?.primaryUnitCode;

  const defaultConversion = allUnits?.find(
    (u) => u?.unitCode === targetUnitCode,
  );

  const isEditMode = data?.cMode === "EDIT";

  const calculateReturnValues = ({
    qty = inputValues.qty,
    returnPrice = inputValues.returnPrice,
    totalReturnAmount = inputValues.totalReturnAmount,
    lock = returnPriceLock,
  }) => {
    const isReturnPriceLock = lock === "RETURN_PRICE";
    const isLineTotalLock = lock === "LINE_TOTAL";
    // console.log(returnPrice);
    // console.log("lock", lock);
    // console.log("totalReturnAmount", totalReturnAmount);
    // console.log("qty", qty);

    const returnPriceSubunit = isReturnPriceLock
      ? CurrencyConverter.toSubunit(Number(returnPrice || 0), "INR")
      : 0;

    const totalReturnSubunit = isLineTotalLock
      ? CurrencyConverter.toSubunit(Number(totalReturnAmount || 0), "INR")
      : 0;
    const quantity = Math.max(1, Number(qty) || 0);
    // console.log({
    //   lock,
    //   returnPriceSubunit,
    //   totalReturnSubunit,
    //   quantity,
    // });
    const amountList = getReturnAmountList(
      data?.mrp,
      data?.saleprice,
      data?.soldprice,
      returnPriceSubunit,
      totalReturnSubunit,
      data?.taxpercentage,
      quantity,
      lock,
    );

    setErrors((prev) => ({
      ...prev,
      returnPrice: "",
      totalReturnAmount: "",
    }));

    if (
      touched.returnPrice &&
      lock === "RETURN_PRICE" &&
      amountList.returnPrice > amountList.soldPrice
    ) {
      setErrors({
        returnPrice: "Return price cannot be greater than the sold price.",
      });
      return;
    }

    if (
      touched.totalReturnAmount &&
      lock === "LINE_TOTAL" &&
      amountList.lineTotalReturnPrice > amountList.lineTotalSoldPrice
    ) {
      setErrors({
        totalReturnAmount:
          "Total return amount cannot be greater than the total sold price.",
      });
      return;
    }
    // console.log("amountList", amountList);

    setInputValues((prev) => ({
      ...prev,
      qty,
      returnPrice: CurrencyConverter.toCurrency(amountList.returnPrice, "INR"),
      totalReturnAmount: CurrencyConverter.toCurrency(
        amountList.lineTotalReturnPrice,
        "INR",
      ),
    }));

    return amountList;
  };

  const handleQtyInputChange = (value) => {
    let parsedValue;

    // Allow decimal when unit conversion is enabled
    if (data?.unitConfig && uRLs?.UNIT === "true") {
      parsedValue = value.replace(/[^0-9.]/g, "");

      const parts = parsedValue.split(".");

      if (parts.length > 2) {
        parsedValue = parts[0] + "." + parts[1];
      }

      if (parts[1]?.length > 3) {
        parsedValue = parts[0] + "." + parts[1].slice(0, 3);
      }
    } else {
      parsedValue = value.replace(/\D/g, "");
    }

    let numericValue = parsedValue ? parseFloat(parsedValue) : "";

    // Max Qty
    if (!isNaN(numericValue) && numericValue > data.quantity) {
      numericValue = data.quantity;
      parsedValue = String(data.quantity);
    }

    setInputValues((prev) => ({
      ...prev,
      qty: parsedValue,
    }));

    calculateReturnValues({
      qty: parsedValue,
    });
  };

  const handleReturnAmountChange = (value) => {
    setTouched((prev) => ({
      ...prev,
      returnPrice: true,
    }));
    let parsedValue = value.replace(/[^0-9.]/g, "");

    const parts = parsedValue.split(".");

    if (parts.length > 2) {
      parsedValue = parts[0] + "." + parts[1];
    }

    if (parts[1]?.length > 2) {
      parsedValue = parts[0] + "." + parts[1].slice(0, 2);
    }

    let amount = parsedValue ? parseFloat(parsedValue) : "";

    const maxAmount = CurrencyConverter.toCurrency(data.soldprice || 0, "INR");

    if (!isNaN(amount) && amount > maxAmount) {
      amount = maxAmount;
      parsedValue = String(maxAmount);
    }

    calculateReturnValues({
      returnPrice: parsedValue,
    });
  };

  const handleTotalReturnAmountChange = (value) => {
    setTouched((prev) => ({
      ...prev,
      totalReturnAmount: true,
    }));

    let parsedValue = value.replace(/[^0-9.]/g, "");

    const parts = parsedValue.split(".");
    if (parts.length > 2) {
      parsedValue = parts[0] + "." + parts[1];
    }

    if (parts[1]?.length > 2) {
      parsedValue = parts[0] + "." + parts[1].slice(0, 2);
    }

    let amount = Number(parsedValue || 0);

    // Maximum allowed amount
    const maxAmount = Number(
      CurrencyConverter.toCurrency(data.lineTotalSoldPrice || 0, "INR"),
    );

    // Replace with max if user enters above max
    if (amount > maxAmount) {
      amount = maxAmount;
      parsedValue = maxAmount;
    }

    calculateReturnValues({
      totalReturnAmount: parsedValue,
      lock: "LINE_TOTAL",
    });
  };

  const handleReturnPriceLockChange = (type) => {
    setReturnPriceLock(type);

    calculateReturnValues({
      qty: inputValues.qty || "1",
      returnPrice: inputValues.returnPrice || "0",
      totalReturnAmount: inputValues.totalReturnAmount || "0",
      lock: type,
    });
  };

  const handleAdd = () => {
    const { soldprice, qty } = inputValues;
    const numericSoldPrice = parseFloat(soldprice);
    const numericQty = parseFloat(qty);

    if (!soldprice || isNaN(numericSoldPrice) || numericSoldPrice <= 0) {
      setSoldPriceError("Enter a valid sale price.");
      soldPriceRef.current?.focus();
      return;
    }

    if (numericSoldPrice > priceState.mrp) {
      setSoldPriceError("Sale price cannot exceed MRP.");
      soldPriceRef.current?.focus();
      return;
    }

    if (!qty || isNaN(numericQty) || numericQty <= 0) {
      setErrors({ qty: "Enter a valid quantity." });
      qtyInputRef.current?.focus();
      return;
    }
    // ✅ Enforce max quantity in edit mode
    if (data.cMode === "EDIT" && data.quantity && numericQty > data.quantity) {
      // setErrors({ qty: `Quantity cannot exceed ${data.quantity}` });
      qtyInputRef.current?.focus();
      return;
    }

    const amountList = calculateReturnValues({
      qty: inputValues.qty,
      returnPrice: inputValues.returnPrice,
      totalReturnAmount: inputValues.totalReturnAmount,
      lock: returnPriceLock,
    });
    const newItem = {
      _id: data._id,
      code: data.code,
      imode: data.imode,
      itemNo: data.itemNo,
      hsnsac: data.hsnsac,
      title: data.title,
      addToStock,
      mrp: amountList.mrp,
      saleprice: amountList.salePrice,
      soldprice: amountList.soldPrice,

      // Return Details
      returnPrice: amountList.returnPrice,
      lineTotalReturnPrice: amountList.lineTotalReturnPrice,
      cancelledPrice: amountList.cancelledPrice,
      lineTotalCancelledPrice: amountList.lineTotalCancelledPrice,

      // Taxes
      baseprice: amountList.basePrice,
      discount: amountList.discount,
      taxpercentage: amountList.taxPercentage,
      taxamount: amountList.taxAmount,
      gstAmount: amountList.gstAmount,
      sgstAmount: amountList.sgstAmount,
      cgstAmount: amountList.cgstAmount,
      igstAmount: amountList.igstAmount,

      // Totals
      lineTotalMrp: amountList.lineTotalMrp,
      lineTotalSalePrice: amountList.lineTotalSalePrice,
      lineTotalSoldPrice: amountList.lineTotalSoldPrice,
      lineGrandTotal: amountList.lineGrandTotal,

      // Quantity & Lock
      quantity: Number(inputValues.qty),
      returnPriceLock,

      isLock: data.isLock,
      isStock: data.isStock,
      note: data.note,

      remark: inputValues.remark,
      conditions: inputValues.conditions,

      ...(data?.unitConfig && {
        unitConfig: data.unitConfig,
        secondaryUnitSelected:
          selectedUnit === data.unitConfig.secondaryUnitCode,
      }),
      ...(data?.cMode && { cMode: data.cMode }),
      ...(data.cIndex !== undefined && {
        cIndex: data.cIndex,
      }),
    };
    // console.log("newItem", newItem);
    addToCart(newItem, Number(inputValues.qty), false);
    onClose();
  };

  const handlePaymodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  const headerClass =
    data?.imode === "PRODUCT"
      ? "bg-light-blue"
      : data?.imode === "SERVICE"
        ? "bg-light-brown"
        : data?.imode === "RECHARGE"
          ? "bg-light-purple"
          : "bg-light";

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  // console.log(data.unitConfig);
  // console.log("selectedUnit", selectedUnit);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">
                {isEditMode ? "Edit Return Item" : "Return Item"}
              </h6>

              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body  bg-light">
              <div className="card mb-0">
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-lg-12 mt-3">
                      <div className="card shadow-none border-blue mb-0">
                        <div className={`card-header ${headerClass} p-2`}>
                          <div className="mb-0">
                            {data?.imode === "PRODUCT"
                              ? "Product Details"
                              : data?.imode === "SERVICE"
                                ? "Service Details"
                                : data?.imode === "RECHARGE"
                                  ? "Recharge Details"
                                  : "Details"}
                          </div>
                        </div>
                        {data ? (
                          <>
                            <div className="card-body p-2">
                              {/* Common */}
                              <div className="d-flex fs-13">
                                <div
                                  className="mb-1 d-flex gap-2"
                                  style={{ flexBasis: "100%" }}
                                >
                                  <span className="fw-semibold text-muted">
                                    {data?.imode === "SERVICE"
                                      ? "Service :"
                                      : data?.imode === "RECHARGE"
                                        ? "Description :"
                                        : "Title :"}
                                  </span>

                                  <span className="fw-600">
                                    {data?.title || data?.description || "-"}
                                  </span>
                                </div>
                              </div>

                              {/* PRODUCT */}
                              {data?.imode === "PRODUCT" && (
                                <>
                                  <div className="d-flex fs-13">
                                    <div
                                      className="mb-1 d-flex align-items-center gap-2"
                                      style={{ flexBasis: "50%" }}
                                    >
                                      <span className="fw-semibold text-muted">
                                        SKU Code:
                                      </span>
                                      {data?.code ? (
                                        <span className="badge rounded-pill bg-label-navy">
                                          {data.code}
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </div>

                                    <div
                                      className="mb-1 d-flex align-items-center gap-2"
                                      style={{ flexBasis: "50%" }}
                                    >
                                      <span className="fw-semibold text-muted">
                                        HSN:
                                      </span>
                                      {data?.hsnsac ? (
                                        <span className="badge rounded-pill bg-label-retro">
                                          {data.hsnsac}
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </div>
                                  </div>

                                  <div className="d-flex fs-13">
                                    <div
                                      className="mb-1 d-flex align-items-center gap-2"
                                      style={{ flexBasis: "50%" }}
                                    >
                                      <span className="fw-semibold text-muted">
                                        Brand:
                                      </span>
                                      {data?.brandId ? (
                                        <span className="badge bg-label-kids">
                                          {data.brandId}
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </div>

                                    <div
                                      className="mb-1 d-flex align-items-center gap-2"
                                      style={{ flexBasis: "50%" }}
                                    >
                                      <span className="fw-semibold text-muted">
                                        Stock Left:
                                      </span>
                                      {data?.stockLeft ? (
                                        <span className="badge bg-label-space">
                                          {Number(
                                            data?.isSecondaryUnit
                                              ? secondaryQuanity(
                                                  data.stockLeft,
                                                  data.unitConfig,
                                                )
                                              : data.stockLeft,
                                          )}
                                          <span className="font-11 ms-1">
                                            {defaultConversion?.unitCode}
                                          </span>
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </div>
                                  </div>

                                  <div className="d-flex fs-13">
                                    <div
                                      className="mb-1 d-flex align-items-center gap-2"
                                      style={{ flexBasis: "50%" }}
                                    >
                                      <span className="fw-semibold text-muted">
                                        Note:
                                      </span>
                                      {data?.note ? (
                                        <span className="badge bg-label-sun">
                                          {data.note}
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </div>

                                    {uRLs.UNIT === "true" && (
                                      <div
                                        className="mb-1 d-flex align-items-center gap-2"
                                        style={{ flexBasis: "50%" }}
                                      >
                                        <span className="fw-semibold text-muted">
                                          Unit:
                                        </span>

                                        {defaultConversion?.unitName ? (
                                          <span className="badge rounded-pill btn-unit">
                                            {defaultConversion.unitName} (
                                            {defaultConversion.unitCode})
                                          </span>
                                        ) : (
                                          "-"
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}

                              {/* SERVICE */}
                              {data?.imode === "SERVICE" && (
                                <>
                                  <div className="d-flex fs-13">
                                    <div
                                      className="mb-1 d-flex align-items-center gap-2"
                                      style={{ flexBasis: "100%" }}
                                    >
                                      <span className="fw-semibold text-muted">
                                        Service By:
                                      </span>

                                      {data?.serviceByName ? (
                                        <span className="badge bg-label-primary">
                                          {data.serviceByName}
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </div>

                                    {uRLs.UNIT === "true" && (
                                      <div
                                        className="mb-1 d-flex align-items-center gap-2"
                                        style={{ flexBasis: "50%" }}
                                      >
                                        <span className="fw-semibold text-muted">
                                          Unit:
                                        </span>

                                        {defaultConversion?.unitName ? (
                                          <span className="badge rounded-pill btn-unit">
                                            {defaultConversion.unitName} (
                                            {defaultConversion.unitCode})
                                          </span>
                                        ) : (
                                          "-"
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </>
                              )}

                              {/* RECHARGE */}
                              {data?.imode === "RECHARGE" && (
                                <>
                                  <div className="d-flex fs-13">
                                    <div
                                      className="mb-1 d-flex align-items-center gap-2"
                                      style={{ flexBasis: "50%" }}
                                    >
                                      <span className="fw-semibold text-muted">
                                        Operator:
                                      </span>

                                      {data?.operator ? (
                                        <span className="badge bg-label-primary">
                                          {data.operator}
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </div>

                                    <div
                                      className="mb-1 d-flex align-items-center gap-2"
                                      style={{ flexBasis: "50%" }}
                                    >
                                      <span className="fw-semibold text-muted">
                                        Number:
                                      </span>

                                      {data?.number ? (
                                        <span className="badge bg-label-success">
                                          {data.number}
                                        </span>
                                      ) : (
                                        "-"
                                      )}
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </>
                        ) : (
                          <p className="mb-1 text-muted">
                            No products has been selected
                          </p>
                        )}
                      </div>
                    </div>

                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="mb-0">Return Details</h6>

                        {data?.isStock === true && (
                          <div className="d-flex align-items-center gap-2">
                            <span className="fw-600">Add to Stock</span>

                            <div className="custom-toggle-wrapper">
                              <label className="custom-toggle cursor-pointer">
                                <input
                                  type="checkbox"
                                  checked={addToStock}
                                  onChange={() =>
                                    setAddToStock((prev) => !prev)
                                  }
                                />

                                <span className="slider">
                                  {addToStock["stock"] ? (
                                    <span
                                      className={`spinner-inside ${
                                        addToStock["stock"]
                                          ? "spinner-right"
                                          : ""
                                      }`}
                                    />
                                  ) : (
                                    <>
                                      {addToStock["stock"] ? (
                                        <span className="label-on ms-0-1"></span>
                                      ) : (
                                        <span className="label-off ms-3"></span>
                                      )}
                                    </>
                                  )}
                                </span>
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="row g-3">
                        {/* Return Amount */}
                        <div className="col-md-4">
                          <label className="form-label">
                            Retrun Rate {data?.unitConfig?.primaryUnitCode}{" "}
                            <span className="text-danger">*</span>
                          </label>

                          <div className="input-container position-relative">
                            <input
                              type="text"
                              className="form-control"
                              value={inputValues.returnPrice}
                              // disabled={returnPriceLock === "LINE_TOTAL"}
                              onClick={() =>
                                handleReturnPriceLockChange("RETURN_PRICE")
                              }
                              style={{ paddingLeft: "30px" }}
                              onChange={(e) =>
                                handleReturnAmountChange(e.target.value)
                              }
                              onFocus={(e) => e.target.select()}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  qtyInputRef.current?.focus();
                                  qtyInputRef.current?.select();
                                }
                              }}
                            />
                            <input
                              type="radio"
                              name="selectInput"
                              checked={returnPriceLock === "RETURN_PRICE"}
                              className="position-absolute"
                              style={{
                                top: "50%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                zIndex: 2,
                              }}
                            />
                          </div>

                          <small className="text-muted">
                            Max : ₹
                            {CurrencyConverter.toCurrency(
                              data.soldprice || 0,
                              "INR",
                            )}
                          </small>
                          {errors.returnPrice && (
                            <small className="text-danger">
                              {errors.returnPrice}
                            </small>
                          )}
                        </div>

                        {/* Quantity */}
                        <div className="col-md-4">
                          <label className="form-label">
                            Quantity <span className="text-danger">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              ref={qtyInputRef}
                              type="text"
                              min="1"
                              max={data.quantity}
                              className="form-control"
                              value={inputValues.qty}
                              onChange={(e) =>
                                handleQtyInputChange(e.target.value)
                              }
                              onFocus={(e) => e.target.select()}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  totalReturnRef.current?.focus();
                                  totalReturnRef.current?.select();
                                }
                              }}
                            />
                            {data?.unitConfig &&
                              uRLs?.UNIT === "true" &&
                              (data?.unitConfig?.secondaryUnitCode ? (
                                <select
                                  className="btn btn-unit shadow-none border-end rounded-end rounded-start-0"
                                  // style={{
                                  //   width: "70px",
                                  //   minWidth: "70px",
                                  // }}
                                  value={selectedUnit}
                                  // onChange={(e) =>
                                  //   handleUnitChange(e.target.value)
                                  // }
                                >
                                  <option
                                    value={data.unitConfig.primaryUnitCode}
                                  >
                                    {data.unitConfig.primaryUnitCode}
                                  </option>

                                  {/* <option value={data.unitConfig.secondaryUnitCode}>
                                {data.unitConfig.secondaryUnitCode}
                              </option> */}
                                </select>
                              ) : (
                                <span
                                  className="btn btn-unit shadow-none border-end rounded-end rounded-start-0"
                                  // style={{
                                  //   width: "70px",
                                  //   minWidth: "70px",
                                  // }}
                                >
                                  {data.unitConfig.primaryUnitCode}
                                </span>
                              ))}
                          </div>
                          <small className="text-muted">
                            Max Qty : {data.quantity}
                          </small>
                        </div>

                        {/* Total Return Amount */}
                        <div className="col-md-4">
                          <label className="form-label">
                            Total Retrun <span className="text-danger">*</span>
                          </label>

                          <div className="input-container position-relative">
                            <input
                              ref={totalReturnRef}
                              type="text"
                              className="form-control"
                              value={inputValues.totalReturnAmount}
                              // disabled={returnPriceLock === "RETURN_PRICE"}
                              onClick={() =>
                                handleReturnPriceLockChange("LINE_TOTAL")
                              }
                              style={{ paddingLeft: "30px" }}
                              onChange={(e) =>
                                handleTotalReturnAmountChange(e.target.value)
                              }
                              onFocus={(e) => e.target.select()}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  handleAdd(); // or addButtonRef.current?.click();
                                }
                              }}
                            />
                            <input
                              type="radio"
                              name="selectInput"
                              checked={returnPriceLock === "LINE_TOTAL"}
                              className="position-absolute"
                              style={{
                                top: "50%",
                                left: "10px",
                                transform: "translateY(-50%)",
                                zIndex: 2,
                              }}
                            />
                          </div>

                          <small className="text-muted">
                            Max : ₹
                            {CurrencyConverter.toCurrency(
                              data.lineTotalSoldPrice || 0,
                              "INR",
                            )}
                          </small>

                          {errors.totalReturnAmount && (
                            <small className="text-danger">
                              {errors.totalReturnAmount}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="row g-3 mt-1">
                        <div className="col-md-6">
                          <label className="form-label">Remark</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter remark"
                            value={inputValues.remark}
                            onChange={(e) =>
                              setInputValues((prev) => ({
                                ...prev,
                                remark: e.target.value,
                              }))
                            }
                          />
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">Conditions</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter conditions"
                            value={inputValues.conditions}
                            onChange={(e) =>
                              setInputValues((prev) => ({
                                ...prev,
                                conditions: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                className="btn btn-outline-secondary text-left"
              >
                <CloseIcon/> Cancel
              </button>
              <button
                ref={buttonRef}
                type="button"
                className="btn btn-primary text-right"
                onClick={handleAdd}
              >
                {data?.cIndex !== undefined ? (
                  <>
                    <CheckIcon/> Update
                  </>
                ) : (
                  <>
                    <AddIcon/> Add
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRetrunProduct;
